import React from "react";

import styles from "../../../../styles/secrets-drawers.module.scss";
import { Drawer } from "../../../components/Drawer";
import { Input } from "../../../components/Input";
import { Button } from "../../../components/Button";
import { EnvironmentsAPI } from "../../../../providers/EnvironmentsAPI";
import { EnvironmentStorage } from "../../../tools/EnvironmentStorage";
import { Icon } from "../../../components/core/Icon";
import { AssetsAPI } from "../../../../providers/AssetsAPI";

export default class GestorThemeDrawer extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            active: true,
            logo: null,
            primaryColor: null,
            secondaryColor: null
        };
    }

    async componentDidMount() {
        const theme = await EnvironmentsAPI.getConfigurationsByAlias(
            await EnvironmentStorage.getEnvironmentHoldingId(),
            'theme'
        );

        this.setState({
            logo: theme?.logo,
            primaryColor: theme?.primaryColor,
            secondaryColor: theme?.secondaryColor,
        })
    }

    async updateTheme() {
        const { logo, primaryColor, secondaryColor } = this.state;

        this.setState({ loading: true });

        const updateResponse = await EnvironmentsAPI.putConfigurationsByAlias(
            await EnvironmentStorage.getEnvironmentHoldingId(),
            'theme',
            { theme: { logo, primaryColor, secondaryColor } }
        );

        if (updateResponse.getErrors([]).length > 0) {
            alert({ text: updateResponse.getErrors()[0], buttonText: "Ok" });
            this.setState({ loading: false });
            return false;
        } else {
            alert({ text: "Tema salvo com sucesso", buttonText: "Ok" });
        }

        this.setState({ loading: false });

        return true;
    }

    async handleSetImage(e) {
        const file = e.target.files[0];

        if (file) {
            const maxFileSize = 5;
            const fileSize = file.size / 1024 / 1024;
            const fileType = file.type;

            if (fileSize > maxFileSize) {
                alert({ text: `Escolha um arquivo com no máximo ${maxFileSize}MB` });
                return false;
            }

            const pattern = /image-*/;

            if (!fileType.match(pattern)) {
                alert({ text: "Arquivo inválido." });
                return false;
            }

            let reader = new FileReader();
            reader.onload = async (readerEvent) => {
                const response = await AssetsAPI.PostAssets({
                    mime_type: fileType,
                    file: readerEvent.target.result.split("base64,")[1],
                });

                this.setState({ logo: response.getData("") });

            };

            reader.readAsDataURL(file);
        }
    };

    render() {
        const { loading, logo, primaryColor, secondaryColor } = this.state;
        const { visible, onClose } = this.props;

        return (
            <Drawer
                visible={visible}
                onClose={onClose}
                closeInFade
                title="Tema - Gestor"
            >
                <div className={styles.secretDrawerContainer}>
                    <div className={styles.container}>
                        <div className="d-flex align-center">
                            <label htmlFor="brand-picture" className={styles.customFileInput}>
                                <span className={styles.plus}>
                                    <Icon name="plus" color="#fff" />
                                </span>
                                <input type="file" id="brand-picture" accept="image/*" onChange={(e) => this.handleSetImage(e)} />
                                {logo ? (
                                    <img src={`${process.env.REACT_APP_ASSETS_URL}/${logo}`} />
                                ) : (
                                    <Icon name="image-polaroid" size="2x" light />
                                )}
                            </label>
                        </div>
                        <Input
                            design="two"
                            className="mb-20"
                            floatLabel="Cor primária"
                            value={primaryColor}
                            onChange={(e) => { this.setState({ primaryColor: e.target.value }) }}
                        />
                        <Input
                            design="two"
                            className="mb-20"
                            floatLabel="Cor secundária"
                            value={secondaryColor}
                            onChange={(e) => { this.setState({ secondaryColor: e.target.value }) }}
                        />
                    </div>
                    <div className={styles.footer}>
                        <Button
                            design="primary"
                            className="w-100"
                            onClick={() => this.updateTheme()}
                            loading={loading}
                            disabled={loading}
                        >
                            Salvar
                        </Button>
                    </div>
                </div>
            </Drawer>
        );
    }
}
